import React, { useState } from 'react';
import { useAppContext } from '../context/AppContext';
import { useTranslation } from 'react-i18next';

const Settings = () => {
  const { t } = useTranslation();
  const { user, setUser } = useAppContext();
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);

  const handleSave = (e) => {
    e.preventDefault();
    setUser(u => ({ ...u, name, email }));
  };

  return (
    <div className="max-w-4xl mx-auto bg-white rounded shadow p-8 mt-8">
      <h2 className="text-2xl font-bold mb-6 text-primary">{t('settings.title')}</h2>
      <form onSubmit={handleSave}>
        <div className="mb-4">
          <label className="block mb-1">{t('settings.nameLabel')}</label>
          <input className="w-full border rounded px-3 py-2" value={name} onChange={e => setName(e.target.value)} />
        </div>
        <div className="mb-4">
          <label className="block mb-1">{t('settings.emailLabel')}</label>
          <input className="w-full border rounded px-3 py-2" value={email} onChange={e => setEmail(e.target.value)} />
        </div>
        <button type="submit" className="bg-primary text-white px-4 py-2 rounded hover:bg-secondary transition-colors">{t('settings.saveChanges')}</button>
      </form>
    </div>
  );
};

export default Settings;
